import React, {FC} from 'react';
import {ColDef} from 'ag-grid-community';
import {FewAvailableLessonsStatisticResponse} from '../../shared/types/report';
import HLPageTable from '../../shared/components/table/HLPageTable';
import {getFewAvailableLessonsStatisticsFetch} from "../../app/axios/reportFetches";
import {useAppSelector} from "../../shared/hooks/useAppSelector";
import {TeacherRole} from "../../shared/types/teacher";

const defaultColDef: ColDef<FewAvailableLessonsStatisticResponse> = {
    sortable: false,
    filter: false,
    resizable: true,
    minWidth: 100,
};

const FewAvailableLessonsStatisticTable: FC = () => {
    const currentTeacher = useAppSelector(state => state.auth.currentTeacher)

    const columnDefs: ColDef<FewAvailableLessonsStatisticResponse>[] = [
        {
            field: 'agreementName',
            headerName: 'Имя договора',
            flex: 2,
        },
        {
            field: 'agreementStudentAvailableLessons',
            headerName: 'Число оставшихся уроков',
            flex: 1,
        },
        {
            field: 'studentFullName',
            headerName: 'Имя ученика',
            flex: 2,
        },
        {
            field: 'studentTelegram',
            headerName: 'Телеграм ученика',
            flex: 2,
            valueFormatter: (params) => params.value ?? '-',
        },
        
    ];
    
    if (currentTeacher?.role !== TeacherRole.ADMIN) return null

    return (
        <HLPageTable
            title="Статистика учеников с малым остатком уроков"
            columns={columnDefs}
            defaultColDef={defaultColDef}
            filterConfig={[]}
            actionButtons={[]}
            rowModelType={"clientSide"}
            fetchData={getFewAvailableLessonsStatisticsFetch}
            height={600}
        />
    );
}

export default FewAvailableLessonsStatisticTable;